import { render, staticRenderFns } from "./ARecibo.vue?vue&type=template&id=7c327f33"
import script from "./ARecibo.vue?vue&type=script&lang=js"
export * from "./ARecibo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports